export default {
  namespaced: true,
  state: () => ({
    hasUnsavedChanges: false,
    hasSaveFallback: false,
  }),
  mutations: {
    SET_HAS_UNSAVED_CHANGES(state, v) {
      state.hasUnsavedChanges = !!v;
    },
    SET_HAS_SAVE_FALLBACK(state, v) {
      state.hasSaveFallback = !!v;
    },
  },
  getters: {
    HAS_UNSAVED_CHANGES: (s) => s.hasUnsavedChanges,
    HAS_SAVE_FALLBACK: (s) => s.hasSaveFallback,
  },
};
